import { env } from "../api/env";
import { rootState } from "./reducers";

export const ID_CLIENTE = (state: any) => state.root.filters.idCliente;
export const ID_TIPO_PERSONA = (state: any) => state.root.filters.idTipoPersona;
export const ID_FINANCIAMIENTO_SOLICITADO = (state: any) => state.root.filters.idFinanciamientoSolicitado;
export const ID_FORO_CONDICIONES = (state: any) => state.root.filters.idForoCondiciones;
export const IsLoading = (state: any) => state.root.isLoading;
export const PATH_SECURE: string = env.BASE_URL + env.PATH_PROTECTED;